import { render, staticRenderFns } from "./discount.vue?vue&type=template&id=7c794846"
import script from "./discount.vue?vue&type=script&lang=ts"
export * from "./discount.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports